import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageToggle } from '../ui/LanguageToggle';

export const Navigation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <nav className="fixed left-0 right-0 z-[1000] bg-brand-bg/95 backdrop-blur-sm border-b border-brand-border py-3.5 transition-all duration-200 top-0">
      <div className="max-w-[1100px] mx-auto px-6 flex items-center justify-between">
        <a href="/" className="flex items-center no-underline">
          <picture>
            <source srcSet="/images/landing/aidfone-logo-horizontal.webp" type="image/webp" />
            <img
              src="/images/landing/aidfone-logo-horizontal.png"
              alt="AidFone"
              className="h-10 w-auto"
              width={540}
              height={121}
            />
          </picture>
        </a>
        <div className="flex items-center gap-3">
          <LanguageToggle />
          <Link
            to="/configure"
            className="inline-flex items-center justify-center px-5 py-2.5 font-body text-sm font-semibold no-underline rounded-md border-none cursor-pointer transition-all bg-brand-accent text-white shadow-[0_4px_14px_rgba(224,123,76,0.35)] hover:bg-[#c96a3f] hover:-translate-y-0.5"
          >
            {t('landing.navigation.ctaPrimary')}
          </Link>
        </div>
      </div>
    </nav>
  );
};
